import { IconProps } from 'types/icon.type'

export const HeartIcon = (props: IconProps) => {
  return (
    <svg
      width="37"
      height="37"
      viewBox="0 0 42 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_2_130"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="42"
        height="43"
      >
        <rect
          x="0.0916748"
          y="0.348755"
          width="41.8167"
          height="41.8167"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_2_130)">
        <path
          d="M20.9836 34.8375C20.6575 34.8375 20.3305 34.7786 20.0027 34.6607C19.6748 34.5428 19.3865 34.3585 19.1376 34.1079L16.9814 32.1377C13.6332 29.0694 10.7072 26.1118 8.20341 23.2648C5.69964 20.4177 4.44775 17.4477 4.44775 14.3548C4.44775 11.9372 5.26289 9.91333 6.89316 8.28306C8.52343 6.6525 10.5415 5.83722 12.9474 5.83722C14.3213 5.83722 15.715 6.17495 17.1287 6.8504C18.542 7.52557 19.8325 8.71139 21.0002 10.4079C22.2347 8.71139 23.5372 7.52557 24.9079 6.8504C26.2782 6.17495 27.6599 5.83722 29.053 5.83722C31.4589 5.83722 33.477 6.6525 35.1072 8.28306C36.7375 9.91333 37.5526 11.9372 37.5526 14.3548C37.5526 17.4811 36.2752 20.4787 33.7203 23.3475C31.1657 26.216 28.2603 29.1454 25.0041 32.1356L22.8393 34.1149C22.593 34.3629 22.3052 34.5452 21.9759 34.662C21.6463 34.779 21.3156 34.8375 20.9836 34.8375ZM20.0062 12.7596C19.0874 11.2057 18.0283 10.0283 16.829 9.22742C15.6299 8.42681 14.3361 8.0265 12.9474 8.0265C11.1185 8.0265 9.60965 8.62398 8.42077 9.81895C7.23161 11.0139 6.63703 12.5289 6.63703 14.3639C6.63703 15.8426 7.10021 17.3815 8.02657 18.9807C8.95321 20.5802 10.1171 22.1678 11.5183 23.7435C12.9191 25.3189 14.4383 26.8523 16.0758 28.3437C17.7131 29.8352 19.2372 31.2224 20.6482 32.5054C20.7487 32.6021 20.866 32.6504 21.0002 32.6504C21.1344 32.6504 21.2517 32.6021 21.3521 32.5054C22.7632 31.2343 24.2873 29.8502 25.9245 28.3529C27.5621 26.8553 29.0801 25.3144 30.4786 23.73C31.8775 22.1453 33.0414 20.5532 33.9703 18.9537C34.899 17.3542 35.3633 15.8224 35.3633 14.3582C35.3633 12.527 34.7656 11.0139 33.57 9.81895C32.3745 8.62398 30.8678 8.0265 29.0499 8.0265C27.6438 8.0265 26.346 8.4239 25.1566 9.21871C23.9671 10.0135 22.9011 11.1938 21.9585 12.7596C21.8348 12.9519 21.6889 13.0949 21.5207 13.1887C21.3523 13.2825 21.1709 13.3294 20.9767 13.3294C20.7824 13.3294 20.5981 13.2825 20.4239 13.1887C20.2497 13.0949 20.1104 12.9519 20.0062 12.7596Z"
          fill={props.color}
        />
      </g>
    </svg>
  )
}
